import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzTableModule } from 'ng-zorro-antd/table';
import { take } from 'rxjs';
import { WorkspaceService } from '../../core/workspace/workspace.service';
import { BoardIconTitleComponent } from '../../domain/board/board-icon-title/board-icon-title.component';
import { InviteTeamMemberListComponent } from '../../domain/team-member/invite-team-member-list/invite-team-member-list.component';
import { WorkspaceListComponent } from '../../domain/workspace/workspace-list/workspace-list.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';

@Component({
  selector: 'app-switch-workspaces',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzStepsModule,
    NzButtonModule,
    NzIconModule,
    NzSkeletonModule,
    NzInputModule,
    NzTableModule,
    NzPopoverModule,

    BasicPageComponent,
    InviteTeamMemberListComponent,
    BoardIconTitleComponent,
    WorkspaceListComponent,
  ],
  templateUrl: './switch-workspaces.component.html',
  styleUrl: './switch-workspaces.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchWorkspacesComponent {
  workspaceName: string = '';

  isAddWorkspaceVisible = false;

  constructor(private workspaceService: WorkspaceService) {}

  onAddWorkspaceClick() {
    this.workspaceService
      .addWorkspace$({ title: this.workspaceName })
      .pipe(take(1))
      .subscribe(() => {});
    this.isAddWorkspaceVisible = false;
  }
}
